import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Flag } from 'angular-feather/icons';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CashServiceService {

  constructor(private httpClient: HttpClient) { }

  //Get all counties
  public getAllCounties() {
    const countyUrl = `${environment.baseUrl}/api/v1/counties`;

    return this.httpClient.get<[]>(countyUrl);
  }

  //Get sub-counties by county
  public getSubCounties(countyName: string) {
    const subUrl = `${environment.baseUrl}/api/v1/counties/${countyName}/subcounties`;

    return this.httpClient.get<[]>(subUrl);
  }

  //Get wards by County and Subcounty
  public getWards(countyName: string, subcountyName: string): Observable<any[]> {
    const wardsUrl = `${environment.baseUrl}/api/v1/counties/${countyName}/${subcountyName}/wards`;

    return this.httpClient.get<[]>(wardsUrl);
  }

  //get all mpesa configs
  public getAllMpesaConfigs(): Observable<any[]> {
    const allUrl = `${environment.baseUrl}/api/mpesa-config/get/all`;

    return this.httpClient.get<[]>(allUrl);
  }

  //get all Caritas configs
  public getAllConfigs(
    churchUnitId?: number,
    activeOnly = false,
    branchId?: number,
    purposeCode?: string,
    approvalStatus?: string
  ): Observable<any[]> {
    const url = `${environment.baseUrl}/api/v1/admin/config/caritas/all`;
    let params = new HttpParams().set('activeOnly', activeOnly.toString());
    if (churchUnitId) {
      params = params.set('churchUnitId', churchUnitId.toString());
    }
    if (branchId) params = params.set('branchId', branchId.toString());
    if (purposeCode) params = params.set('purposeCode', purposeCode);
    if (approvalStatus) params = params.set('approvalStatus', approvalStatus);
    return this.httpClient.get<any[]>(url, { params });
  }

  //get all configured churches
  public getAllChurches(): Observable<any[]> {
    const allUrl = `${environment.baseUrl}/api/churches/main/churches`;

    return this.httpClient.get<[]>(allUrl);
  }

  public getBankBranches(): Observable<any> {
    return this.httpClient.get<any>(`${environment.baseUrl}/api/v1/bank-branches/all`);
  }

  // Generic GET method
  public getCustomChurches(): Observable<any> {
    const custom = `${environment.baseUrl}/api/churches/others/churches`;
    return this.httpClient.get<[]>(custom);
  }

  // get system roles
  public getSystemRoles(): Observable<any[]> {
    const allUrl = `${environment.baseUrl}/api/roles/assignable`;

    return this.httpClient.get<[]>(allUrl);
  }

  //get system roles by id
  public getRoleById(id: number): Observable<any> {
    const roleUrl = `${environment.baseUrl}/auth/role/find/${id}`;

    return this.httpClient.get<any>(roleUrl);
  }


  // get leadership roles
  public getLeadershipRoles(param: any): Observable<any[]> {
    const allUrl = `${environment.baseUrl}/api/v1/church-leadership-roles/by-deleted-flag?deletedFlag=${param}`;

    return this.httpClient.get<[]>(allUrl);
  }


  public getchurchUnitsById(churchId: number): Observable<any[]> {
    const allUrl = `${environment.baseUrl}/church-units/level/${churchId}`;

    return this.httpClient.get<[]>(allUrl);
  }

  //get all church units
  // public getAllChurchUnits(): Observable<any[]> {
  //   const allUrl = `${environment.baseUrl}/church-units/church-units/branch`;

  //   return this.httpClient.get<[]>(allUrl);
  // }
  public getAllChurchUnits(branchId: number): Observable<any[]> {
  const url = `${environment.baseUrl}/church-units/all`;
  return this.httpClient.get<any[]>(url, {
    params: { branchId: branchId.toString() }
  });
}
public getRmChurchUnits():Observable<any>{
  const url = `${environment.baseUrl}/church-units/all`;
  return this.httpClient.get<any>(url);
}

public getPagedChurchUnits(filters: {
  page: number;
  size: number;
  search?: string;
  branchId?: number;
  withoutBranch?: boolean;
  approvalStatus?: string;
  excludeApprovalStatus?: string;
  denomination?: string;
}): Observable<any> {
  let params = new HttpParams()
    .set('page', filters.page.toString())
    .set('size', filters.size.toString());
  if (filters.search) params = params.set('search', filters.search);
  if (filters.branchId != null) params = params.set('branchId', filters.branchId.toString());
  if (filters.withoutBranch) params = params.set('withoutBranch', 'true');
  if (filters.approvalStatus) params = params.set('approvalStatus', filters.approvalStatus);
  if (filters.excludeApprovalStatus) params = params.set('excludeApprovalStatus', filters.excludeApprovalStatus);
  if (filters.denomination) params = params.set('denomination', filters.denomination);
  return this.httpClient.get<any>(`${environment.baseUrl}/church-units/paged`, { params });
}

public getChurchUnitsByParishId(parishId: number): Observable<any> {
  const url = `${environment.baseUrl}/api/v1/outstation/fetch/all/${parishId}`;
  return this.httpClient.get<any>(url);
}


  getChurchUnitsByChurchId(churchId: number): Observable<any> {
  const url = `${environment.baseUrl}/church-units/church/${churchId}`;
  return this.httpClient.get<any>(url);
}
  

  //get church units per branch
  public getChurchUnitsByBranch(branchId?: number): Observable<any []> {
    let churchUrl = `${environment.baseUrl}/church-units/all`;
    if (branchId) {
      churchUrl += `?branchId=${branchId}`
    }

    return this.httpClient.get<[]>(churchUrl);
  }

  //get all congregations
  public getAllCongregations(): Observable<any[]> {
    const allUrl = `${environment.baseUrl}/api/v1/shirika/get/active-shirikas`;

    return this.httpClient.get<[]>(allUrl);
  }

  // get church unit profiles
  public getAllChurchUnitProfiles(): Observable<any[]> {
    const allUrl = `${environment.baseUrl}/api/church-unit-profile/get/active`;

    return this.httpClient.get<[]>(allUrl);
  }
  public deactivateChurchUnit(id: number): Observable<any> {
  const url = `${environment.baseUrl}/church-units/${id}/deactivate`;
  return this.httpClient.put(url, {}, { responseType: 'text' });
}
getChurchUnitFiles(churchUnitId: number) {
  return this.httpClient.get<any[]>(`${environment.baseUrl}/api/kyc/list/${churchUnitId}`);
}

public reactivateChurchUnit(id: number): Observable<any> {
  const url = `${environment.baseUrl}/church-units/${id}/activate`;
  return this.httpClient.put(url, {},{ responseType: 'text' }); // use {} instead of null for clarity
}

  // public rejectChurchUnit(id: number): Observable<any> {
  //   const deactivateUrl = `${environment.baseUrl}/church-units/${id}/reject`;
    
  //   return this.httpClient.put(deactivateUrl, null);
  // }

  rejectChurchUnit(id: number, reason: string) {
  const url = `${environment.baseUrl}/church-units/reject`;
  const body = { id, reason };
  return this.httpClient.put(url, body);
}

  // public restoreChurchUnit(id: number): Observable<any> {
  //   const deactivateUrl = `${environment.baseUrl}/church-units/${id}/reject`;
    
  //   return this.httpClient.put(deactivateUrl, null);
  // }
  // public approveChurchUnit(id: number): Observable<any> {
  //   const deactivateUrl = `${environment.baseUrl}/church-units/${id}/approve`;
    
  //   return this.httpClient.put(deactivateUrl, null);
  // }
  // Post Church configurations
  public postChurch(churchData: any): Observable<any> {
    const postUrl = `${environment.baseUrl}/api/churches/create`;

    return this.httpClient.post<any>(postUrl, churchData);
  }
  
  

   // Step 1: Create Church Unit Profile
  public churchUnitProfile(profileData: any): Observable<any> {
    const postUrl = `${environment.baseUrl}/api/church-unit-profile/create`;
    return this.httpClient.post<any>(postUrl, profileData);
  }

   // Step 2: Configure Email Settings
  public configureEmailSettings(churchUnitId: number, emailConfigData: any): Observable<any> {
    const postUrl = `${environment.baseUrl}/api/v1/config/mail/${churchUnitId}`;
    return this.httpClient.post<any>(postUrl, emailConfigData);
  }

  // Update Email Configuration
  public updateEmailSettings(churchUnitId: number, emailConfigData: any): Observable<any> {
    const updateUrl = `${environment.baseUrl}/api/v1/config/mail/${churchUnitId}`;
    return this.httpClient.put<any>(updateUrl, emailConfigData);
  }

  // Get Email Configuration
  public getEmailConfig(churchUnitId: number): Observable<any> {
    const getUrl = `${environment.baseUrl}/api/v1/config/mail/${churchUnitId}`;
    return this.httpClient.get<any>(getUrl);
  }

  // Step 3: Configure SMS Settings
  public configureSmsSettings(churchUnitId: number, smsConfigData: any): Observable<any> {
    const postUrl = `${environment.baseUrl}/api/v1/config/sms/${churchUnitId}`;
    return this.httpClient.post<any>(postUrl, smsConfigData);
  }

  // Update SMS Configuration
  public updateSmsSettings(churchUnitId: number, smsConfigData: any): Observable<any> {
    const updateUrl = `${environment.baseUrl}/api/v1/config/sms/${churchUnitId}`;
    return this.httpClient.put<any>(updateUrl, smsConfigData);
  }

  // Get SMS Configuration
  public getSmsConfig(churchUnitId: number): Observable<any> {
    const getUrl = `${environment.baseUrl}/api/v1/config/sms/${churchUnitId}`;
    return this.httpClient.get<any>(getUrl);
  }

  // Step 4: Configure Account Settings
  public configureAccountSettings(accountConfigData: any): Observable<any> {
    const postUrl = `${environment.baseUrl}/api/v1/admin/config/caritas/create`;
    return this.httpClient.post<any>(postUrl, accountConfigData);
  }

  public createAccountSettingsBatch(accountConfigData: any): Observable<any[]> {
    const postUrl = `${environment.baseUrl}/api/v1/admin/config/caritas/batch`;
    return this.httpClient.post<any[]>(postUrl, accountConfigData);
  }

  public saveAccountSettingsBatch(accountConfigData: any): Observable<any[]> {
    const putUrl = `${environment.baseUrl}/api/v1/admin/config/caritas/batch`;
    return this.httpClient.put<any[]>(putUrl, accountConfigData);
  }

  public updateAccountConfig(id: number, accountData: any): Observable<any> {
    const accountUrl = `${environment.baseUrl}/api/v1/admin/config/caritas/update/${id}`;
    return this.httpClient.put<any>(accountUrl, accountData);
  }

  public deactivateAccountConfig(id: number): Observable<void> {
    const accountUrl = `${environment.baseUrl}/api/v1/admin/config/caritas/delete/${id}`;
    return this.httpClient.delete<void>(accountUrl);
  }

  public getAccountGovernanceDashboard(churchUnitId: number): Observable<any> {
    return this.httpClient.get(`${environment.baseUrl}/api/v1/account-governance/dashboard/${churchUnitId}`);
  }

  public getAccountPurposes(): Observable<any[]> {
    return this.httpClient.get<any[]>(`${environment.baseUrl}/api/v1/account-governance/purposes`);
  }

  public requestAccountCreation(accountData: any): Observable<any> {
    return this.httpClient.post(`${environment.baseUrl}/api/v1/account-governance/accounts`, accountData);
  }

  public requestAccountUpdate(id: number, accountData: any): Observable<any> {
    return this.httpClient.post(`${environment.baseUrl}/api/v1/account-governance/accounts/${id}/changes`, accountData);
  }

  public requestAccountDeactivation(id: number, reason: string): Observable<any> {
    return this.httpClient.post(`${environment.baseUrl}/api/v1/account-governance/accounts/${id}/deactivation`, { reason });
  }

  public requestPaymentRoute(churchUnitId: number, paymentType: string, caritasConfigId: number, reason: string): Observable<any> {
    return this.httpClient.post(
      `${environment.baseUrl}/api/v1/account-governance/parishes/${churchUnitId}/payment-routes/${paymentType}`,
      { caritasConfigId, reason }
    );
  }

  public approveAccountRequest(id: number, comments: string): Observable<any> {
    return this.httpClient.post(`${environment.baseUrl}/api/v1/account-governance/requests/${id}/approve`, { comments });
  }

  public rejectAccountRequest(id: number, reason: string): Observable<any> {
    return this.httpClient.post(`${environment.baseUrl}/api/v1/account-governance/requests/${id}/reject`, { reason });
  }

  public cancelAccountRequest(id: number, reason: string): Observable<any> {
    return this.httpClient.post(`${environment.baseUrl}/api/v1/account-governance/requests/${id}/cancel`, { reason });
  }

  public getCashGovernanceDashboard(churchUnitId: number): Observable<any> {
    return this.httpClient.get(`${environment.baseUrl}/api/v1/cash-governance/dashboard/${churchUnitId}`);
  }

  public submitCashGovernanceTransaction(data: any): Observable<any> {
    return this.httpClient.post(`${environment.baseUrl}/api/v1/cash-governance/transactions`, data);
  }

  public approveCashGovernanceTransaction(id: number, comments: string): Observable<any> {
    return this.httpClient.post(`${environment.baseUrl}/api/v1/cash-governance/transactions/${id}/approve`, { comments });
  }

  public rejectCashGovernanceTransaction(id: number, reason: string): Observable<any> {
    return this.httpClient.post(`${environment.baseUrl}/api/v1/cash-governance/transactions/${id}/reject`, { reason });
  }

  public cancelCashGovernanceTransaction(id: number, reason: string): Observable<any> {
    return this.httpClient.post(`${environment.baseUrl}/api/v1/cash-governance/transactions/${id}/cancel`, { reason });
  }

  // Step 5: Create Church Admin User
  public createChurchAdminUser(cleanData: any): Observable<any> {
    const postUrl = `${environment.baseUrl}/api/v1/AppUser/create/churchAdmin`;
    return this.httpClient.post<any>(postUrl, cleanData);
  }


  // Post Congregation
  public postCongregation(congregationData: any): Observable<any> {
    const postUrl = `${environment.baseUrl}/api/v1/shirika/create`;

    return this.httpClient.post<any>(postUrl, congregationData);
  }


  // Create Hierarchy
  public createHierarchy(hierarchyData: any): Observable<any> {
    const postUrl = `${environment.baseUrl}/api/church-unit-levels/create`;

    return this.httpClient.post<any>(postUrl, hierarchyData);
  }


  // Create Hierarchy
  public createChurchUnits(unitsData: any): Observable<any> {
    const postUrl = `${environment.baseUrl}/church-units/create`;

    return this.httpClient.post<any>(postUrl, unitsData);
  }

  public getClergyCategoriesForUnit(churchUnitId: number): Observable<any> {
    return this.httpClient.get<any>(
      `${environment.baseUrl}/api/clergy-categories/for-unit/${churchUnitId}`
    );
  }

  public registerOnboardingPatron(churchUnitId: number, payload: any): Observable<any> {
    return this.httpClient.post<any>(
      `${environment.baseUrl}/api/v1/governance/clergy-identities/units/${churchUnitId}/onboarding-patron`,
      payload
    );
  }

  public downloadBulkSetupTemplate(parishId: number): Observable<Blob> {
    return this.httpClient.get(
      `${environment.baseUrl}/api/v1/outstation/upload/template?parishId=${parishId}`,
      { responseType: 'blob' }
    );
  }

  public uploadBulkSetup(file: File, parishId: number): Observable<any> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    formData.append('parishId', parishId.toString());
    return this.httpClient.post<any>(
      `${environment.baseUrl}/api/v1/outstation/upload`,
      formData
    );
  }

  // load parent levels
  public getParentLevels(churchId: any): Observable<any> {
    const churchUrl = `${environment.baseUrl}/api/church-unit-levels/${churchId}/levels`;

    return this.httpClient.get<any>(churchUrl);
  }

  //load church structure
  public getStructureLevels(churchId: any): Observable<any> {
    const churchUrl = `${environment.baseUrl}/api/church-unit-levels/${churchId}/levels`;

    return this.httpClient.get<any>(churchUrl);
  }

   public getParentLevel(churchId: any): Observable<any> {
    const churchUrl = `${environment.baseUrl}/api/church-unit-levels/${churchId}/levels/WithNoChild`;

    return this.httpClient.get<any>(churchUrl);
  }

  public getAccountVerification(configId: number): Observable<any> {
    return this.httpClient.get<any>(
      `${environment.baseUrl}/api/v1/account-verification/accounts/${configId}`
    );
  }

  public requestAccountProviderVerification(configId: number): Observable<any> {
    return this.httpClient.post<any>(
      `${environment.baseUrl}/api/v1/account-verification/accounts/${configId}/provider-check`, {}
    );
  }

  public attestAccountManually(configId: number, attestation: any): Observable<any> {
    return this.httpClient.post<any>(
      `${environment.baseUrl}/api/v1/account-verification/accounts/${configId}/manual-attestation`,
      attestation
    );
  }

  public recordAccountVerificationFailure(configId: number, failure: any): Observable<any> {
    return this.httpClient.post<any>(
      `${environment.baseUrl}/api/v1/account-verification/accounts/${configId}/failure`,
      failure
    );
  }

  public revokeAccountVerification(configId: number, reason: string): Observable<any> {
    return this.httpClient.post<any>(
      `${environment.baseUrl}/api/v1/account-verification/accounts/${configId}/revoke`,
      { reason }
    );
  }

  public getHierarchyOptions(filters: {
    churchId: number; levelId: number; parentId?: number; search?: string; page: number; size: number;
  }): Observable<any> {
    let params = new HttpParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') params = params.set(key, String(value));
    });
    return this.httpClient.get<any>(`${environment.baseUrl}/church-units/options`, { params });
  }

  public getHierarchyUnit(churchId: number, id: number): Observable<any> {
    return this.httpClient.get<any>(`${environment.baseUrl}/church-units/options/${id}`, {
      params: new HttpParams().set('churchId', String(churchId))
    });
  }

  // load parent units

  public getParentUnits(levelId: any): Observable<any> {
    const churchUrl = `${environment.baseUrl}/church-units/levels/${levelId}/parent-units`;

    return this.httpClient.get<any>(churchUrl);
  }

  public getchurchUnitStructureLevels(levelId: any): Observable<any> {
    const churchUrl = `${environment.baseUrl}/church-units/levels/${levelId}/parent-units`;

    return this.httpClient.get<any>(churchUrl);
  }

  // load church hierarchies
  public getChurchHierarchies(churchId: any): Observable<any> {
    const churchUrl = `${environment.baseUrl}/api/church-unit-levels/${churchId}/levels/hierarchy`;

    return this.httpClient.get<any>(churchUrl);
  }

  public getChurchUnits(parentId: any): Observable<any> {
    const churchUrl = `${environment.baseUrl}/church-units/parent/${parentId}`;

    return this.httpClient.get<any>(churchUrl);
  }


  // createUser
  public saveUser(userData: any): Observable<any> {
    const postUrl = `${environment.baseUrl}/api/v1/AppUser/create/staff`;

    return this.httpClient.post<any>(postUrl, userData);
  }

  public addUser(userData: any): Observable<any> {
    const branchUrl = `${environment.baseUrl}/api/v1/AppUser/create/branch-staff`;

    return this.httpClient.post<any>(branchUrl, userData);
  }

  // create church Admin
  public createChurchAdmin(adminDataData: any): Observable<any> {
    const postUrl = `${environment.baseUrl}/api/v1/AppUser/create/churchAdmin`;

    return this.httpClient.post<any>(postUrl, adminDataData);
  }

  // create church Admin by church admin
  public createChurchAdminByChurchAdmin(adminData: any): Observable<any> {
    const postUrl = `${environment.baseUrl}/api/v1/AppUser/create/by-church-admin`;
    return this.httpClient.post<any>(postUrl, adminData);
  }
//   public createLeadershipsRole(postedBy: string, leadershipName: string): Observable<any> {
//   const params = new HttpParams().set('postedBy', postedBy);
//   const body = { leadershipName };
//   const allUrl = `${environment.baseUrl}/api/v1/church-leadership-roles`;

//   return this.httpClient.post<any>(allUrl, body, { params });
// }

  // create church unit profiles
  public createChurchUnitProfile(adminDataData: any): Observable<any> {
    const postUrl = `${environment.baseUrl}/api/church-unit-profile/create`;

    return this.httpClient.post<any>(postUrl, adminDataData);
  }

  //post mpesa config into the database
  public postMpesaConfig(mpesaData: any): Observable<any> {
    const postUrl = `${environment.baseUrl}/api/mpesa-config/add`;

    return this.httpClient.post<any>(postUrl, mpesaData);
  }

  public postAccountConfig(accountData: any): Observable<any> {
    const url = `${environment.baseUrl}/api/v1/admin/config/caritas/create`;

    return this.httpClient.post<any>(url, accountData);
  }

  //modify church config
  public updateChurch(churchId: number, updateChurchData: any): Observable<any> {
    const updateUrl = `${environment.baseUrl}/api/churches/${churchId}`;

    return this.httpClient.put<any>(updateUrl, updateChurchData);
  }

  // cash-service.service.ts
approveOrRejectChurch(churchId: number, action: 'APPROVE' | 'REJECT') {
  return this.httpClient.post(
    `${environment.baseUrl}/api/churches/${churchId}/approve`,
    {}, // body is empty
    { params: { action } }
  );
}
getSystemUsersByParish(parishId: number): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.get(`${environment.baseUrl}/api/v1/auth/systemUsersDetails/${parishId}`, { headers });
  }

  getChurchAdminsByRm(): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.httpClient.get(`${environment.baseUrl}/api/leadership/churchAdminsByRm`, { headers });
  }

   getChurchProfilebyId(churchId: any): Observable<any> {
    const churchUnitProfileUrl = `${environment.baseUrl}/api/church-unit-profile/get/${churchId}/profile`;

    return this.httpClient.get<any>(churchUnitProfileUrl);
  }
  getFileInfo(fileId: number) {
  return this.httpClient.get<any>(
    `${environment.baseUrl}/api/kyc/download/${fileId}`,
    { observe: 'response', responseType: 'blob' as 'json' }
  );
}


  public getChurchUnitById(id: number): Observable<any> {
    const getUrl = `${environment.baseUrl}/church-units/${id}`;
    return this.httpClient.get<any>(getUrl);
  }

  public updateChurchUnit(id: number, unitData: any): Observable<any> {
    const updateUrl = `${environment.baseUrl}/church-units/${id}`;
    return this.httpClient.put<any>(updateUrl, unitData);
  }



  //approve church config
  public approveChurch(churchId: number): Observable<any> {
    const updateUrl = `${environment.baseUrl}/api/churches/${churchId}/approve`;

    return this.httpClient.post<any>(updateUrl, churchId);
  }
  public deleteChurch(churchId: number): Observable<any> {
    const deleteUrl = `${environment.baseUrl}/api/churches/${churchId}`;
    return this.httpClient.delete(deleteUrl);
  }
  
  activateChurchUnit(id: string | number): Observable<any> {
    return this.httpClient.put(`${environment.baseUrl}/${id}/activate`, {});
  }

  /**
   * Deactivates a church unit.
   */
  // deactivateChurchUnit(id: string | number): Observable<any> {
  //   return this.httpClient.put(`${environment.baseUrl}/${id}/deactivate`, {});
  // }

  /**
   * Soft-deletes a church unit.
   */
  

   public deactivateChurch(id: number, headers: HttpHeaders): Observable<string> {
  const url = `${environment.baseUrl}/api/churches/${id}/deactivate`;

  return this.httpClient.put(url, null, {
    headers,
    responseType: 'text' as 'text'  
  });
}

  public activateChurch(id: number, headers: HttpHeaders): Observable<any> {
  
    const approveChurchUnitUrl = `${environment.baseUrl}/api/churches/${id}/activate`;

    return this.httpClient.put(approveChurchUnitUrl, null, {headers, responseType: 'text' });
  }
  public restoreChurch(churchId: number, headers: HttpHeaders): Observable<any> {
  
    const approveChurchUnitUrl = `${environment.baseUrl}/api/churches/${churchId}/restore`;

    return this.httpClient.patch(approveChurchUnitUrl, null, {headers, responseType: 'text' });
  }
  deleteChurchUnit(id: string | number): Observable<any> {
    return this.httpClient.put(`${environment.baseUrl}/church-units/${id}/delete`, {});
  }

  restoreChurchUnit(id: string | number): Observable<any> {
    return this.httpClient.put(`${environment.baseUrl}/church-units/${id}/restore`, {});
  }
  public approveChurchUnit(id: number): Observable<any> {
    const approveChurchUnitUrl = `${environment.baseUrl}/api/church/check/${id}`;
    return this.httpClient.post<any>(approveChurchUnitUrl, {});
  }

  public submitChurchUnit(churchUnitId: number): Observable<any> {
    const submitChurchUnitUrl = `${environment.baseUrl}/church-units/${churchUnitId}/submit`;
    return this.httpClient.post(submitChurchUnitUrl, {});
  }

  public uploadDocument(churchUnitId: number, fileType: string, formData: FormData): Observable<any> {
  const postUrl = `${environment.baseUrl}/api/kyc/upload?churchUnitId=${churchUnitId}&fileType=${fileType}`;
  return this.httpClient.post<any>(postUrl, formData);
}

  public updateDocument(fileId: number, formData: FormData): Observable<any> {
    const updateUrl = `${environment.baseUrl}/api/kyc/update/${fileId}`;
    return this.httpClient.put<any>(updateUrl, formData);
  }

  //update config
  public pudateConfig(paybillNumber: number, updateConfigData: any): Observable<any> {
    const updateUrl = `${environment.baseUrl}/api/mpesa-config/update/${paybillNumber}`;

    return this.httpClient.put<any>(updateUrl, updateConfigData);
  }
  public deleteConfig(paybillNumber: number): Observable<any> {
    const deleteUrl = `${environment.baseUrl}/api/mpesa-config/delete/${paybillNumber}`;

    return this.httpClient.delete<any>(deleteUrl);
  }

  //login the supper User to access the mpesa configuratio
  public loginSuperuser(superData: any): Observable<any> {
    const supperuserUrl = `${environment.baseUrl}/api/v1/AppUser/signin`;

    return this.httpClient.post<any>(supperuserUrl, superData)
  }

  //get a member by phone number
  public getMemberByPhoneNumber(phoneNo: number): Observable<any> {
    const phoneUrl = `${environment.baseUrl}/api/v1/auth/find/by/phoneNumber/${phoneNo}`;

    return this.httpClient.get<any>(phoneUrl);
  }

  //post cohort into the database
  public postCohort(cohortData: any): Observable<any> {
    const cohortUrl = `${environment.baseUrl}/api/cohorts/create`;

    return this.httpClient.post<any>(cohortUrl, cohortData);
  }
  //get the ongoing cohorts from the database
  public getOngoingCohorts(parishId: number): Observable<any[]> {
    const ongoingUrl = `${environment.baseUrl}/api/cohorts/get/${parishId}/ongoing`;

    return this.httpClient.get<any[]>(ongoingUrl);
  }

  //update congregations
  public updateCongregation(id: number, updateData: any): Observable<any> {
    const updateUrl = `${environment.baseUrl}/api/v1/shirika/update/${id}`;

    return this.httpClient.put<any>(updateUrl, updateData);
  }

  //delete congregations
  public deleteCongregation(id: number): Observable<any> {
    const updateUrl = `${environment.baseUrl}/api/v1/shirika/delete/${id}`;

    return this.httpClient.delete<any>(updateUrl);
  }

  //update cohort in the database
  public updateOngoingCohort(id: number, updateData: any): Observable<any> {
    const updateUrl = `${environment.baseUrl}/api/cohorts/update/${id}`;

    return this.httpClient.put<any>(updateUrl, updateData);
  }
  //get ongoingCohorts by cohort Id
  public getOngoingByCohortId(cohortId: number, parishId: number): Observable<any[]> {
    const getUrl = `${environment.baseUrl}/api/cohorts/get/${cohortId}/ongoing/${parishId}`;

    return this.httpClient.get<any[]>(getUrl);
  }

  public createSelfHelpGroup(groupData: any): Observable<any> {
    const postUrl = `${environment.baseUrl}/api/v1/self-help-group/create`;

    return this.httpClient.post<any>(postUrl, groupData, {
      headers: { 'Content-Type': 'application/json' }
    });
  }

  public editSelfHelpGroups(shgId: number, updateData: any): Observable<any> {
    const updateUrl = `${environment.baseUrl}/api/v1/self-help-group/update/${shgId}`;


    return this.httpClient.put<any>(updateUrl, updateData);
  }

  public deleteSelfHelpGroups(shgId: number): Observable<any> {
    // const deleteUrl = `http://localhost:8085/api/v1/self-help-group/delete/${shgId}`;
    const deleteUrl = `${environment.baseUrl}/api/v1/self-help-group/delete/${shgId}`;
    return this.httpClient.delete<any>(deleteUrl);

  }

  public getActiveSelfHelpGroups(): Observable<any[]> {
    // const getUrl = `http://localhost:8085/api/v1/self-help-group/get-active-shgs`;
    const getUrl = `${environment.baseUrl}/api/v1/self-help-group/get-active-shgs`;
    return this.httpClient.get<any[]>(getUrl);
  }

  // Generate detailed enrollment report
  public generateDetailedEnrollmentReport(churchUnitId: number, cohortId: number, params?: any): Observable<any> {
    const options = {
      responseType: 'blob' as 'blob',
      withCredentials: false,
      params: params
    };
    const reportUrl = `${environment.baseUrl}/api/v1/reports/stages/detail/${churchUnitId}/${cohortId}`;
    return this.httpClient.get(reportUrl, options).pipe(
      map((response: Blob) => {
        return {
          data: new Blob([response], { type: 'application/pdf' }),
        };
      })
    );
  }

  // Generate summary enrollment report
  public generateSummaryEnrollmentReport(churchUnitId: number, cohortId: number, params?: any): Observable<any> {
    const options = {
      responseType: 'blob' as 'blob',
      withCredentials: false,
      params: params
    };
    const reportUrl = `${environment.baseUrl}/api/v1/reports/stages/summary/${churchUnitId}/${cohortId}`;
    return this.httpClient.get(reportUrl, options).pipe(
      map((response: Blob) => {
        return {
          data: new Blob([response], { type: 'application/pdf' }),
        };
      })
    );
  }

  public getEligibleCaritasAccounts(churchUnitId: number): Observable<any> {
    return this.httpClient.get(`${environment.baseUrl}/api/v1/church-units/${churchUnitId}/eligible-caritas-accounts`);
  }
}
